<template>
  <el-dialog
    title="编辑发票抬头"
    :visible.sync="dialogVisible"
    width="520px"
    custom-class="invoice-settings-dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="!saving"
    :show-close="!saving"
    append-to-body
    @open="resetForm"
  >
    <el-form ref="form" :model="form" :rules="rules" :disabled="saving" label-width="100px" label-position="left" size="small" @submit.native.prevent="save">
      <el-form-item label="发票抬头" required>
        <el-input v-model="form.company_name" disabled placeholder="企业名称" />
      </el-form-item>
      <el-form-item label="税号" required>
        <el-input v-model="form.org_code" disabled placeholder="纳税人识别号" />
      </el-form-item>
      <el-form-item label="注册地址" prop="contract_address">
        <el-input v-model.trim="form.contract_address" placeholder="请输入企业地址" />
      </el-form-item>
      <el-form-item label="联系电话" prop="contract_mobile">
        <el-input :value="form.contract_mobile" inputmode="numeric" placeholder="请输入联系电话" @input="form.contract_mobile = $event.replace(/\D/g, '')" />
      </el-form-item>
      <el-form-item label="开户银行" prop="bank_name">
        <el-input v-model.trim="form.bank_name" placeholder="请输入开户银行" />
      </el-form-item>
      <el-form-item label="开户账户" prop="bank_number">
        <el-input :value="form.bank_number" inputmode="numeric" placeholder="请输入开户银行账号" @input="form.bank_number = $event.replace(/\D/g, '')" />
      </el-form-item>
      <!-- <el-form-item label="是否默认抬头" prop="is_default" class="invoice-settings-default">
        <el-radio-group v-model="form.is_default">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="invoice-settings-footer">
      <el-button :disabled="saving" @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="saving" @click="save">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'InvoiceSettingsDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    saving: {
      type: Boolean,
      default: false
    },
    invoiceInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {
        company_name: '',
        org_code: '',
        contract_address: '',
        contract_mobile: '',
        bank_name: '',
        bank_number: '',
        is_default: 1
      },
      rules: {
        bank_name: [{ required: true, whitespace: true, message: '请输入开户银行', trigger: 'blur' }],
        bank_number: [{ required: true, whitespace: true, message: '请输入开户银行账号', trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      }
    }
  },
  methods: {
    resetForm() {
      this.form = {
        company_name: this.invoiceInfo.company_name ?? '',
        org_code: this.invoiceInfo.org_code ?? '',
        contract_address: this.invoiceInfo.contract_address ?? '',
        contract_mobile: this.invoiceInfo.contract_mobile ?? '',
        bank_name: this.invoiceInfo.bank_name ?? '',
        bank_number: this.invoiceInfo.bank_number ?? '',
        is_default: 1
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    save() {
      if (this.saving) return
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.$emit('save', { ...this.form })
      })
    }
  }
}
</script>

<style lang="less">
.invoice-settings-dialog {
  max-width: calc(100vw - 24px);
  border-radius: 16px;
  overflow: hidden;
  font-family: inherit;
  font-size: 14px;

  .el-dialog__header {
    padding: 12px 40px;
    text-align: center;
    background: #ff8000;
  }

  .el-dialog__title {
    color: #fff;
    font-size: 17px;
    font-weight: 600;
    line-height: 24px;
  }

  .el-dialog__headerbtn {
    top: 16px;
    right: 16px;

    .el-dialog__close { color: #fff; }
    &:focus-visible { outline: 2px solid #fff; outline-offset: 3px; }
  }

  .el-dialog__body { padding: 28px 60px 0; }
  .el-form-item { margin-bottom: 14px; }
  .el-form-item__label { color: var(--text-secondary); font-size: 14px; }
  .el-input__inner { border-radius: 4px; font-family: inherit; font-size: 14px; }
  .el-input.is-disabled .el-input__inner { background: #f3f4f6; color: #737d8c; }
  .el-input__inner:focus { border-color: #ff8000; }
  .el-radio { margin-right: 24px; }
  .el-radio__label { padding-left: 6px; font-size: 14px; }
  .el-radio__input.is-checked .el-radio__inner { background: #ff8000; border-color: #ff8000; }
  .el-radio__input.is-checked + .el-radio__label { color: var(--text-body); }
  .invoice-settings-default { margin-bottom: 0; }
  .el-dialog__footer { padding: 28px 60px 36px; }

  .invoice-settings-footer {
    display: flex;
    gap: 16px;

    .el-button { flex: 1; min-width: 0; height: 38px; margin: 0; padding: 0 12px; font-family: inherit; font-size: 14px; }
    .el-button--primary { background: #ff8000; border-color: #ff8000; }
    .el-button--primary:hover,
    .el-button--primary:focus { background: #ed6c00; border-color: #ed6c00; }
  }

  @media (max-width: 480px) {
    .el-dialog__body { padding: 24px 20px 0; }
    .el-dialog__footer { padding: 28px 20px 32px; }
  }
}
</style>
